import React, { useEffect, useRef, useState } from 'react'
import Loader from '../../../components/Loader/Loader'
import { useAboutDetailQuery } from '../../../helpers/aboutApi'
import { staggerContainer } from '../../../utils/motion'
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/effect-coverflow";
import "swiper/css/navigation";
import "swiper/css/autoplay";

import { EffectCoverflow, Navigation, Autoplay } from "swiper";
import { motion } from 'framer-motion';
import { useMediaQuery } from '@mui/material';
import { StyledStoriesSection } from '../../../components/Developers/style';


const Leaders = () => {

    const [slideData, setslideData] = useState([])

    const { data, isFetching } = useAboutDetailQuery()

    const [currentSlide, setCurrentSlide] = useState(0);
    const smallerthen640 = useMediaQuery('(max-width:768px)')

    const swiperRef = useRef(null)

    useEffect(() => {

        if (slideData.length) {
            swiperRef.current.swiper.slideToLoop(currentSlide);
        }

    }, [currentSlide, slideData]);


    useEffect(() => {

        if (data && data.about[0].leaders.length && data.about[0].show) {
            setslideData(data.about[0].leaders)
        }

    }, [data]);


    return (
        <div>
            <motion.div
                variants={staggerContainer}
                initial="hidden"
                whileInView="show">
                {isFetching ? <Loader height={'40vh'} text='loading...' /> : (
                    <div>
                        {data.about[0].show && (
                            <div className='max-w-screen-2xl mx-auto py-5 px-2  md:px-10'>
                                <div className='md:pb-10'>
                                    <h1
                                        className='text-xl dark:text-white md:text-2xl font-bold text-center text-yellow-500'
                                    >
                                        {data.about[0].title}
                                    </h1>
                                    <p className='text-center text-[15px] my-2 mx-auto md:max-w-[700px] dark:text-white'>
                                        {data.about[0].desc}
                                    </p>

                                    <StyledStoriesSection>

                                        <div className="md:w-[80%] mx-auto  my-6 md:my-10">
                                            <Swiper
                                                onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
                                                grabCursor={true}
                                                loop={true}
                                                autoplay={{
                                                    pauseOnMouseEnter: true,
                                                }}
                                                ref={swiperRef}
                                                centeredSlides={true}
                                                slidesPerView={smallerthen640 ? 1 : 3}
                                                speed={800}
                                                spaceBetween={35}
                                                navigation={true}
                                          
                                                modules={[ Navigation, Autoplay]}
                                                className="w-full "
                                                style={{
                                                    "--swiper-navigation-size": "20px",
                                                    padding: '30px',
                                                    marginTop: '35px'
                                                }}
                                            >
                                                {slideData.length && slideData.map((item, i) => (

                                                    <SwiperSlide
                                                        className={`w-full ${currentSlide !== i && 'mt-4'}`}
                                                        key={i}
                                                        onClick={() => setCurrentSlide(i)}

                                                    >
                                                        <div className={`relative cursor-pointer h-[300px] md:h-[320px] ${currentSlide === i ? 'bg-white rounded-xl shadow-2xl p-1.5 hover:scale-95 duration-700' : 'opacity-80'}`}>
                                                            <img src={item.img} alt='img' className={` w-full h-full rounded-xl`} />
                                                         
                                                        </div>
                                                        <div className="relative z-50">

                                                            <motion.div

                                                                variants={{
                                                                    visible: { opacity: 1, y: 0 },
                                                                    hidden: { opacity: 0, y: 70 }
                                                                }}
                                                                initial="hidden"
                                                                animate={currentSlide === i ? "visible" : "hidden"}
                                                                transition={{ duration: 1.0 }}

                                                            >
                                                                {currentSlide === i && (
                                                                    <div className="bg-white relative z-30 mt-3 p-2 rounded-md shadow-md hover:scale-95 duration-700">

                                                                        <h1 className="font-bold text-red-500 text-sm">
                                                                            {item.name}
                                                                        </h1>
                                                                        <p className="text-[15px] my-1 text-gray-600">
                                                                            {item.post}
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </motion.div>
                                                        </div>

                                                    </SwiperSlide>

                                                ))}



                                            </Swiper>
                                        </div>
                                    </StyledStoriesSection>

                                </div>
                            </div>
                        )}
                    </div>
                )}
            </motion.div>
        </div>
    )
}

export default Leaders